import type {
  AllPermissionsResponse,
  FormattedPermission
} from '@library/types/permissions';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';
import { transformPermissions } from '@bo-utils/user';

const { admin } = apiPaths;

export const permissionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPermissions: build.query<Array<FormattedPermission>, void>({
      query: () => ({
        url: `${admin}permissions`,
        method: 'GET',
        params: {
          per_page: 200 // TODO: short term solution for now
        },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformResponse: (response: AllPermissionsResponse) =>
        transformPermissions(response),
      providesTags: ['Permissions']
    })
  })
});

export const { useGetPermissionsQuery } = permissionsApi;
